import { render, staticRenderFns } from "./LazyLoader.vue?vue&type=template&id=5508267c"
import script from "./LazyLoader.vue?vue&type=script&lang=js"
export * from "./LazyLoader.vue?vue&type=script&lang=js"
import style0 from "./LazyLoader.vue?vue&type=style&index=0&id=5508267c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports